import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-gray-600 px-3 py-4"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "p-3 mk-body-strong mk-text-gray-900"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "block mk-font-medium mk-label" }
const _hoisted_6 = { class: "block mk-text-gray-600 mk-body" }
const _hoisted_7 = {
  key: 1,
  class: "border-t mt-2 pt-2"
}
const _hoisted_8 = { class: "py-4 px-3 mk-label mk-text-gray-600 mk-font-medium w-full hover:bg-gray-200 rounded" }

import { useRouter } from 'vue-router';
import { BaseCard } from '@/lib/components/Card';
import { useI18n } from 'vue-i18n';

interface IScrollSpyOptions {
  label?: string;
  description?: string;
  link?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ScrollSpy',
  props: {
    title: null,
    options: null,
    canLoadMore: { type: Boolean },
    noOptionsText: null
  },
  setup(__props: any) {



const router = useRouter();

const handleButtonClick = (link: string) => {
  if (!link) {
    return;
  }
  router.push(`#${link}`);
};

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseCard), {
    padding: "2",
    class: "py-2 px-2 shadow-md"
  }, {
    default: _withCtx(() => [
      (!__props.options?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.noOptionsText || _unref(t)('custom.uhb.pathways.no-submissions')), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (__props.title)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.title), 1))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (item) => {
              return (_openBlock(), _createElementBlock("button", {
                key: item.link,
                class: "block py-4 px-3 text-left hover:bg-gray-200 rounded w-full",
                onClick: ($event: any) => (handleButtonClick(item.link))
              }, [
                _createElementVNode("strong", _hoisted_5, _toDisplayString(item.label), 1),
                _createElementVNode("span", _hoisted_6, _toDisplayString(item.description), 1)
              ], 8, _hoisted_4))
            }), 128)),
            (__props.canLoadMore)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("button", _hoisted_8, _toDisplayString(_unref(t)('custom.uhb.pathways.load-more')), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
    ]),
    _: 1
  }))
}
}

})